import { JOB_DONE_EVENT_PREFIX } from "../../types";
import { REMAINING_EVENT } from "../../types";
import { executeClientJob } from ".";
import { getStaticOptions } from "../../utils";
import { jobDelay } from "..";
/**
 * Convert a client job to promise.
 */ function convertClientJobToPromise(queue, job) {
    const { type } = job;
    const fn = async ()=>{
        const updateRemaining = ()=>{
            const { remaining } = getStaticOptions();
            if (remaining[type]) {
                remaining[type][0] -= 1;
            }
            document.dispatchEvent(new CustomEvent(REMAINING_EVENT, {
                detail: {
                    remaining
                }
            }));
        };
        try {
            const success = await executeClientJob(job);
            updateRemaining();
            document.dispatchEvent(new CustomEvent(`${JOB_DONE_EVENT_PREFIX}${type}`, {
                detail: {
                    job,
                    success
                }
            }));
        } catch (e) {
            // Something went wrong between request and executor - we pause the queue here cause
            // we wait for the next refresh of the page.
            queue.handler.pause();
        }
    };
    const delay = ()=>jobDelay(job);
    return [
        fn,
        delay
    ];
}
export { convertClientJobToPromise };
